/**
 * View mode: cards — 3 wide horizontal bar outlines.
 * Used for the intermediate "card" view on mobile.
 * Uses `currentColor`. No internal SVG padding — caller handles spacing.
 */
export function ViewCards({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      {/* 3 card bars — 20×5 each, 2px gap, 2px edge padding */}
      <rect x="2" y="2"  width="20" height="4" rx="0" />
      <rect x="2" y="10" width="20" height="4" rx="0" />
      <rect x="2" y="18" width="20" height="4" rx="0" />
    </svg>
  )
}
